import React, { useState, useEffect, useRef } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { CFormLabel } from '@coreui/react'
import Select from 'react-select'
import { Calendar } from 'lucide-react'

const RescheduleDatePicker = ({ allowedDates, providers, daysMap, locations, selectedDate, selectProvider, onDateChange, onProviderChange, selectedProvider, setSelectedProvider, setSelectDate, facilityDays, isInFacility, accordionState, selectedIsInFacility }) => {
  const wrapperRef = useRef(null)
  const datepickerRef = useRef(null)
  const [allDayData, setAllDayData] = useState([])
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    try {
      const facilityId = facilityDays?.ID
      const facilityName = String(facilityDays?.Name || '').trim().toLowerCase()

      const availableProviders = (providers || [])
        .map((provider) => {
          const matchedFacility = (provider?.Facilities || []).find((facility) => {
            const providerFacilityId = facility?.FacilityID ?? facility?.facilityID ?? facility?.FacilityId ?? facility?.facilityId ?? facility?.ID ?? facility?.id
            const providerFacilityName = String(facility?.FacilityName ?? facility?.facilityName ?? facility?.Name ?? facility?.name ?? '').trim().toLowerCase()

            return (
              (facilityId !== undefined && facilityId !== null && String(providerFacilityId) === String(facilityId)) ||
              (facilityName && providerFacilityName === facilityName)
            )
          })

          if (!matchedFacility) return null

          return {
            ...provider,
            MatchedFacility: matchedFacility,
          }
        })
        .filter(Boolean)
        .sort((providerA, providerB) => (providerA?.Name || '').trim().toLowerCase().localeCompare((providerB?.Name || '').trim().toLowerCase()))

      setAllDayData(availableProviders)
    } catch (e) {
      console.error('Failed to prepare reschedule providers:', e)
      setAllDayData([])
    }
  }, [facilityDays, providers])

  const isDateAllowed = (date) => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const currentDate = new Date(date)
    currentDate.setHours(0, 0, 0, 0)

    return currentDate >= today
  }

  const toggleCalendar = () => {
    setIsOpen((prev) => !prev)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className="d-flex justify-content-center align-items-center flex-column gap-3 my-3" ref={wrapperRef} onClick={(e) => e.stopPropagation()}>
      {/* Date Picker Section */}
      <div>
        <CFormLabel>Select Date</CFormLabel>
        <div style={{ position: 'relative', display: 'block', width: '300px' }}>
          <DatePicker
            ref={datepickerRef}
            selected={selectedDate}
            onChange={(date) => {
              setSelectDate(date)
              setSelectedProvider(null)
              setIsOpen(false)
            }}
            onInputClick={toggleCalendar}
            filterDate={isDateAllowed}
            placeholderText="Select a date"
            open={isOpen}
            shouldCloseOnSelect={true}
            className="form-control pe-5 custom-datepicker-input"
            dateFormat="MM/dd/yyyy"
          />
          <Calendar
            onClick={toggleCalendar}
            size={18}
            title="Toggle calendar"
            style={{
              position: 'absolute',
              top: '50%',
              right: '12px',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#555',
              pointerEvents: 'auto',
            }}
          />
        </div>
      </div>

      {/* Provider Dropdown */}
      <div style={{ position: 'relative', display: 'block', width: '300px' }}>
        <CFormLabel>Select Provider</CFormLabel>
        <div className="">
          <Select
            options={allDayData.map((item) => ({ value: item.ID, label: item.Name }))}
            onChange={(e) => {
              setSelectedProvider(e)
            }}
            value={selectedProvider || false}
            className="react-select-container"
            classNamePrefix="react-select"
          />
        </div>
      </div>
    </div>
  )
}

export default RescheduleDatePicker
